import {
    PARAMETERS_LIST_PROGRESS,
    PARAMETERS_LIST,
    PARAMETERS_BY_CLIENT,
    PARAMETERS_BY_CLIENT_PROGRESS,
    PARAMETERS_BY_ID,
    PARAMETERS_BY_ID_PROGRESS,
    PARAMETERS_LIST_BY_PARATYPE_PROGRESS,
    PARAMETERS_LIST_BY_PARATYPE
} from '../actions/parametersAction';

export const parametersListReducer = (state={},action)=>{
    switch(action.type){
        case PARAMETERS_LIST_PROGRESS:
        return true;
        case PARAMETERS_LIST:
        return action.data
        default:
        return state;
    }
}
export const parametersListByParaTypeReducer = (state={},action)=>{
    switch(action.type){
        case PARAMETERS_LIST_BY_PARATYPE_PROGRESS:
        return true;
        case PARAMETERS_LIST_BY_PARATYPE:
        return action.data
        default:
        return state;
    }
}

export const parametersByClientReducer = (state={},action)=>{
    switch(action.type){
        case PARAMETERS_BY_CLIENT_PROGRESS:
        return { loading: true,};
        case PARAMETERS_BY_CLIENT:
        return action.data
        default:
        return state;
    }
}
export const parametersByIDReducer = (state={},action)=>{
    switch(action.type){
        case PARAMETERS_BY_ID_PROGRESS:
        return  true;
        case PARAMETERS_BY_ID:
        return action.data
        default:
        return state;
    }
}